<template>
  <!-- 创建积分优惠券 -->
  <div class="createPlayStep new-input-box">
    <div class="create_coupons" v-if="isShow">
      <div class="backBox">
        <!-- <img class="pointer" @click="retrunMethod()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
        <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="retrunMethod()">返回</jd-button>
        <template v-if="activityData && activityData.name">
          <span class="backBox_name">{{ activityData.name }}</span>
        </template>
        <template v-else>
          <span class="txt" v-if="tabActive == 30" @change="changeTab(tabActive)">E卡</span>
          <span class="txt" v-if="tabActive == 29" @change="changeTab(tabActive)">京豆</span>
        </template>
      </div>

      <div :class="{ formBox: localStep != 0 }">
        <!-- 步骤条 -->
        <div class="stepBox">
          <el-steps class="bz" :space="300" :active="localStep">
            <el-step title="活动模板"></el-step>
            <el-step title="设置规则"></el-step>
            <el-step title="完成发布"></el-step>
          </el-steps>
        </div>

        <div class="firststep" v-if="localStep == 0">
          <!-- <div class="tishi"> -->
          <!--  -->
          <div class="activeEdit_bottom">
            <div class="template">
              <div style="width: 82px;padding-top: 5px;">模板类型：</div>
              <div class="template-nav">
                <div
                  class="template-wz pointer"
                  v-for="(item, index) in tempSwitchList"
                  :key="item.id"
                  :class="{ activeTem: index == 0 }"
                  v-show="item.isVisible"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <!-- m模板图 -->
            <div class="templateBox">
              <!-- 定制 -->
              <div class="temImg">
                <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF;">
                  <div class="temImg_content_img temImg_dz">
                    <div class="temImg_dz_center">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                      <span>品牌定制</span>
                    </div>
                  </div>
                  <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
                </div>
              </div>
              <!-- 模板 -->
              <div class="temImg" v-for="item in giftList" :key="item.id">
                <div class="temImg_content">
                  <div class="temImg_content_img">
                    <img style="width:100%;max-height: 380px;" :src="item.templateUrl" alt="" />
                  </div>
                  <div class="temImg_content_wz">
                    <span class="temImg_title">{{ item.imageName }}</span>
                    <span class="temImg_desc">模板ID：{{ item.id }}</span>
                  </div>
                </div>
                <!-- hover -->
                <div class="temImg_content_bgshadow">
                  <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div>
                  <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                  <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item)">使用此模板</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="localStep == 1">
          <!-- 兑换表单 -->
          <main class="main">
            <el-form :model="form" :rules="rules" ref="form" label-width="120px">
              <el-form-item label="礼品名称:" required>
                <el-input v-model="form.activityName" maxlength="15" show-word-limit placeholder="请填入活动名称" style="width: 320px"></el-input>
              </el-form-item>
              <!-- 活动对象 -->
              <informationForm
                @selectPeopleSure="selectPeopleSure"
                @getMemberFn="resetMemberFn"
                :defaultActMember.sync="form.ruleDTO.activityTargetType"
                :plusObject.sync="form.ruleDTO.plusObject" 
                :isCheckOpenCardTime.sync="form.ruleDTO.isCheckOpenCardTime" 
                :openCardStartTime.sync="form.ruleDTO.openCardStartTime" 
                :openCardEndTime.sync="form.ruleDTO.openCardEndTime" 
                :peopleSelected.sync="peopleSelected"
                v-model="form.ruleDTO"
                :activityId="9"
                :localStepNum="16"
                :isEdit="false"
                :disabled="false"
                :needNonMember="true"
                :showOpenCardTip="true"
                :basicInformation="false"
                :customerPaperwork="customerPaperwork"
                @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
              >
              </informationForm>
              <el-form-item label="兑换类型:" required v-if="tabActive == 29">
                <el-radio-group v-model="form.exchangeType" @change="form.exchangeType == 1 ? setQuantityTotal() : null">
                  <el-radio :label="0">自由兑换</el-radio>
                  <el-radio :label="1">套餐兑换</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="参与条件:" required v-if="tabActive == 30">
                <el-radio-group v-model="form.ruleDTO.exchangeConditions">
                  <el-radio :label="0">满足参与身份即可参与</el-radio>
                  <el-radio :label="1">先下单后兑换</el-radio>
                </el-radio-group>
                <participationConditions
                  v-if="form.ruleDTO.exchangeConditions == 1"
                  v-model="form.ruleDTO"
                />
              </el-form-item>

              <el-form-item label="礼品图片:" required>
                <div></div>
                <el-upload
                  ref="upload"
                  action="#"
                  list-type="picture-card"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :http-request="httpRequest"
                  :file-list="fileList"
                >
                  <!-- <img v-if="form.logo" :src="form.logo" style="width: 146px; height: 146px" />
                <i class="el-icon-plus" v-else></i> -->
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
                <span style="color: red; font-size: 14px">建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span>
              </el-form-item>

              <template v-if="tabActive == 29">
                <el-form-item label="选择发豆账户:" required v-if="venderType" @change="getAccountBalance">
                  <el-select v-model="accountCode" placeholder="请选择">
                    <el-option
                      v-for="item in accountCodeList"
                      :key="item.accountCode"
                      :label="item.accountCode"
                      :value="item.accountCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="次数限制:" required>
                  <el-radio-group v-model="form.frequencyType" @change="upodata">
                    <el-radio :label="1">每人每日兑换次数</el-radio>
                    <el-radio :label="2">每人活动内兑换次数</el-radio>
                  </el-radio-group>
                  <div>
                    <el-input v-model="form.limitVal" @input="form.limitVal = getNumberData(1, $event, 0, 1, 20)" placeholder="请输入" style="width: 120px"></el-input>
                    次（最多20次）
                  </div>
                </el-form-item>
                <el-form-item label="数量限制:" v-if="form.exchangeType == 0">
                  <span>每人每日兑换数量</span>
                  <el-input v-model="form.exchangeDayNum" placeholder="不限制" @input="form.exchangeDayNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
                  <span>京豆，每人活动内兑换数量</span>
                  <el-input v-model="form.exchangeNum" placeholder="不限制" @input="form.exchangeNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
                  <span>京豆</span>
                  <div style="color:red;font-size: 14px;line-height: 22px;">
                    注意：1.每人每日兑换数量不可大于每人活动内兑换数量<br />
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 2.未填写限制数量则表示不限
                  </div>
                </el-form-item>
                <el-form-item label="京豆套餐:" required v-else>
                  <el-table
                    :data="form.exchangeSet"
                    border
                    style="width: 542px; border: 1px solid #f0f0f0"
                    :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                    :cell-style="{ 'text-align': 'left' }"
                  >
                    <el-table-column prop="singleNum" label="单个套餐京豆数量（个）" width="210">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.singleNum"
                          @input="scope.row.singleNum = getNumberData(1, $event, 0, 1)"
                          @input.native="
                            setQuantityTotal('1',$event);
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="total" label="套餐数量（个）" width="210">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.total"
                          @input="scope.row.total = getNumberData(1, $event, 0, 1)"
                          @input.native="
                            setQuantityTotal();
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="date" label="操作" width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.$index === 0">--</span>
                        <jd-button
                          v-else
                          type="blueText"
                          @click="
                            form.exchangeSet.splice(scope.$index, 1);
                            setQuantityTotal();
                          "
                          >删除</jd-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="color: red;" v-if="isShowTips">因官方接口限制，单次发豆数量上限是1000，超过时会分多次发放，为确保发放成功，京豆计划发放次数必大于等于单份奖励个数/1000</div>
                  <jd-button type="break" style="margin-top:10px;" @click="form.exchangeSet.push({singleNum: null,total: null})">添加套餐</jd-button>
                </el-form-item>
              </template>
              <el-form-item label="兑换次数限制:" v-if="tabActive == 30">
                <span> 活动期间每人每天最多可兑换</span>
                <el-input v-model="form.exchangeDayNum" placeholder="不限制" @input="form.exchangeDayNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
                <span>次，累计每人最多可兑换</span>
                <el-input v-model="form.exchangeNum" placeholder="不限制" @input="form.exchangeNum = getNumberData(1, $event, 0, 1)" style="width: 136px;margin:0 5px;"></el-input>
                <span>次</span>
                <div style="color:red;font-size: 14px;line-height: 22px;">
                  注意:1.每人每日兑换数量不可大于每人活动内兑换数量<br />
                  ⒉未填写限制数量则表示不限
                </div>
              </el-form-item>
              <el-form-item label="选择E卡:" required v-if="tabActive == 30">
                <el-select v-model="form.assetsId" placeholder="请选择" @change="handleAssidChange">
                  <el-option label="1元" :value="2"></el-option>
                  <el-option label="5元" :value="3"></el-option>
                  <el-option label="20元" :value="4"></el-option>
                  <el-option label="50元" :value="5"></el-option>
                  <el-option label="100元" :value="6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发行总量:" required>
                <el-input v-model="form.quantityTotal" @input="form.quantityTotal = getNumberData(1, $event, 0, 1)" :disabled="form.exchangeType == 1" style="width: 136px"></el-input
                >{{ tabActive == 29 ? "个" : "张" }}
                <div v-if="tabActive == 30">
                  <span style="color:#fe4d45;">{{
                    form.assetsId ? (form.assetsId == 2 ? 1 : form.assetsId == 3 ? 5 : form.assetsId == 4 ? 20 : form.assetsId == 5 ? 50 : 100) : ""
                  }}</span
                  >元E账户余量：<span style="color:#fe4d45;">{{ quantityBalance }}</span
                  >张
                </div>
                <div v-else>
                  账户余量：<span style="color:#fe4d45;">{{ quantityBalanceJd }}</span
                  >京豆
                </div>
                <div style="color:red;font-size:14px;">注意：活动发放总量不能大于账户剩余量，礼品发放数到达总量后，兑换活动自动结束</div>
              </el-form-item>

              <el-form-item label="上下架时间:" required>
                <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.startTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 135px; font-size: 12px"
                    class="time1"
                    @change="activityTimeChange"
                    :picker-options="pickerOptionsValue"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="form.endTime"
                    type="datetime"
                    placeholder="选择日期时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 150px; font-size: 12px"
                    class="time2"
                    @change="activityTimeChange"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
                  <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
                </div>
                <span class="lastTime">
                  活动持续
                  <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut }}</span> 小时
                  <el-tooltip class="item" effect="light" content="活动时间不可超过互动数据授权有效期及店铺接入有效期" placement="bottom">
                    <el-button type="text" style="width: 35px;">
                      <i class="el-icon-question" style="color:#ccc"></i>
                    </el-button>
                  </el-tooltip>
                  <!-- <span style="color: #fe4d45;">23</span> 小时  -->
                </span>
              </el-form-item>

              <el-form-item label="兑换所需等级:" required>
                <div class="level-wrap">
                  <el-checkbox-group v-model="memberLe" @change="checkListchange">
                    <el-checkbox :label="memberLe">全部</el-checkbox>
                  </el-checkbox-group>
                  <el-checkbox-group
                    v-model="level"
                    v-for="(item, index) in memberLevelList"
                    :key="index"
                    @change="checkTheChange"
                  >
                    <el-checkbox :label="item.value" :disabled="memberLe == true" v-if="item.label">{{ item.label }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>

              <el-form-item label="兑换所需积分:" required>
                <div class="isLevelSet" style="width: 600px">
                  <template v-if="!isLevelSet">
                    <el-input v-model.number="form.memberLevelPoints" @input="form.memberLevelPoints = getNumberData(1, $event, 0, 1),upodata()" style="width: 136px;"></el-input>
                    积分=1{{ tabActive == 29 ? "京豆" : "E卡" }}
                  </template>
                  <template v-else>
                    <ul class="levelList">
                      <li class="item" v-for="item in memberLevelList" :key="item.value">
                        {{ item.label }}
                        <el-input
                          v-model.number="item.point"
                          placeholder="请输入..."
                          @input="item.point = getNumberData(1, $event, 0, 1)"
                          style="width: 80px"
                        ></el-input>
                        积分=1{{ tabActive == 29 ? "京豆" : "E卡" }}
                      </li>
                    </ul>
                  </template>
                  <jd-button type="break" @click="isLevel" style="margin-left: 8px">
                    {{ isLevelSet == false ? "按会员等级设置" : "统一设置" }}
                  </jd-button>
                </div>
              </el-form-item>

              <el-form-item label="规则说明:" required>
                <div
                  style="
                  width: 720px;
                  backgroundcolor: rgba(250, 250, 250, 1);
                  padding-top: 8px;
                "
                >
                  <el-input type="textarea" class="textarea" style="width: 704px" resize="none" :rows="6" v-model="form.ruleDescription"></el-input>

                  <div style="margin-top: 8px">
                    <jd-button type="break" @click="generativerule">生成规则</jd-button>
                    <span class="txt">点击按钮自动生成规则，也可以自己编辑信息</span>
                  </div>
                </div>
              </el-form-item>
              <!-- <div class="pd20">
                <jd-title label="展示店铺"></jd-title>
              </div>
              <el-form-item label="小程序店铺信息：" label-width="150px">
                  <el-radio-group v-model="customerPaperwork.shopNameType">
                      <el-radio :label="0">统一显示配置店铺</el-radio>
                      <el-radio :label="2">不显示店铺信息</el-radio>
                  </el-radio-group>
              </el-form-item> -->
              <!-- 新增字段 -->
              <el-form-item label="是否重点活动:" required>
                <div class="flexc-cen-x mt10">
                  <el-radio-group v-model="isKeyActivity">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <template slot="content">
                      <div>
                        大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                      </div>
                    </template>
                    <i class="new-icon-box ml8"></i>
                  </el-tooltip>
                </div>
              </el-form-item>
              <el-form-item label="活动投放位置:" required>
                <el-checkbox-group v-model="placementPosition">
                  <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
                  <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
                  <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
                  <el-checkbox label="SHOP">店铺</el-checkbox>
                  <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
                  <el-checkbox label="OTHER">其他渠道</el-checkbox>
                  <el-tooltip class="item" effect="dark" placement="top">
                    <template slot="content">
                      <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                    </template>
                    <i class="new-icon-box ml8"></i>
                  </el-tooltip>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </main>

          <!-- 底部按钮 -->
          <!-- <footer class="foot">
          <button class="backBtn" @click="retrunMethod()">返回上一页</button>
          <button class="keepBtn" @click="setActivity" v-preventReClick>
            保存并完成设置
          </button>
        </footer> -->

          <!-- 添加优惠券 -->
          <add-coupon :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>

          <!-- 自营=====添加优惠券 -->
          <self-support-addCoupon
            :isShow="selfSupportAddCouponIsShow"
            @close="selfSupportAddCouponIsShow = false"
            @funcMes="addStatusCoupon"
          ></self-support-addCoupon>
        </div>
      </div>
      <div class="create_bottom" v-if="localStep != 0">
        <jd-button style="margin-right: 8px" @click="retrunMethod()">返回上一页</jd-button>
        <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">存为草稿</jd-button>
        <jd-button type="blue" @click="setActivity" v-preventReClick>
          保存并完成设置
        </jd-button>
      </div>
      <!-- 选择商品弹窗 -->
      <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
        <input-form  :inputData="commodityList" @toParentVal="searchContent" :immediately="true"></input-form>
        <div class="new-table-box" style="margin-top: 20px">
          <el-table
            :data="tableShopData"
            stripe
            style="width: 100%;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column width="100">
              <template slot-scope="scope">
                <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
              </template>
            </el-table-column>
            <el-table-column prop="skuName" label="商品名称" width="300">
              <template slot-scope="scope">
                <a :href="scope.row.itemUrl" target="_blank"
                  >{{ scope.row.skuName }}<br />
                  ¥{{ scope.row.jdPrice }}</a
                >
                <!-- <span>{{ scope.row.skuName }}</span
                ><br />
                <span>¥{{ scope.row.jdPrice }}</span> -->
              </template>
            </el-table-column>
            <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <jd-button type="blueText" @click="chooseShop(scope.row)">选择</jd-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="new-pagination-page" style="margin-top: 16px">
          <el-pagination
            style="text-align: right"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 30, 50, 100]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>
        
      </el-dialog>
    </div>
  </div>
</template>

<script>
import informationForm from "@/views/interactiveMarketing/activity/components/informationForm.vue";
import addCoupon from "./add_coupon.vue";
import selfSupportAddCoupon from "./selfSupport_add_coupon.vue"; //自营
import inputForm from "@/components/jhk/inputForm";
import { querydetail, closeSellerCouponWrite } from "@/api/jhk/integralCenter/couponWriteController.js";
import QRCode from "qrcodejs2";
import { getTaobaoItemListSku, getSellercats } from "@/api/jhk/analysis/ware-controller.js";
import {getSupplierAccountList} from "@/api/jhk/integralCenter/prizeCenter.js";
import {
  setActivityList,
  uploadpic,
  setActivityVenderType,
  setActivityListBean,
  pointsExchange,
  pointsBean,
  pointsEcard,
  accountBalance,
  inquireActivity
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { mapState } from "vuex";
import { modifyData } from '../../../utils/util2.js';
import participationConditions from "@/views/interactiveMarketing/activity/components/participationConditions.vue";
const useFormData = (context) => {
  return {
    logo: "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E4%BA%AC%E8%B1%86.png",
    activityName: "",
    ruleDescription: "",
    price: null,
    exchangeTimes: null,
    quantityTotal: null,
    assetsId: null,
    startTime: null,
    endTime: null,
    memberLevelPoints: "",
    couponRedemptionType: "",
    exchangeDayNum: "",
    exchangeNum: "",
    exchangeType: 0, // 兑换类型: 0自由兑换 1套餐兑换
    frequencyType: 1, // 次数限制  后端不需要的参数，前端自定义
    limitVal: "", //后端不需要的参数，前端自定义 frequencyType（0传form.exchangeDayTimes）frequencyType（1传form.exchangeTimes）
    exchangeSet: [
      // 套餐： json数组 [{"id":1,"singleNum":5,"total":10,"actual":0}] id，套餐id，singleNum单份数量，total套餐数量，actual已兑换套餐数量
      {
        singleNum: null,
        total: null,
      },
    ],
    ruleDTO: {
      activityTargetType: '1',
      partner: ["-1"],
      allowLevel: "-1",
      condFollow: false,
      openCardFollow: false,
      isValidBlackList: false,
      plusObject: 0,
      crowdIds: "",
      firstOpenCardTimeType: 0,
      openCardBeforeDay: "",
      orderCompleteLimitCount: "",
      orderCompleteMaxCount: "",
      orderCompleteLimitPayment: "",
      orderCompleteMaxPayment: "",
      lastOrderCompleteTimeType: 0,
      lastOrderCompleteStartDay: "",
      lastOrderCompleteEndDay: "",
      lastOrderCompleteStartTime: "",
      lastOrderCompleteEndTime: "",
      isCheckOpenCardTime: "",
      openCardStartTime: "",
      openCardEndTime: "",
      exchangeConditions: 0,
      orderStartTime: "",
      orderEndTime: "",
      orderPaymentType: 0,
      filterType: 0,
      skuIdList: [],
      itemLimitCount: "",
      orderPaymentLimit: "",
      orderType: 0,
      orderCountType: 0,
      goShopSetting: 0,
      goShopAppId: "",
      goShopUrl: "",
      filterSkuType: 0,
    },
  }
};
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 29,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    addCoupon,
    inputForm,
    selfSupportAddCoupon,
    informationForm,
    participationConditions
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.isCopy;
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    venderType:{
        handler(newVal) {
        if(newVal) {
          this.getSupplierList()
        }
      },
      immediate:true
    },
    venderId: {
      handler(newVal) {
        if(newVal&&this.venderType) {
          this.formAccount.accountCode = newVal
          this.formAccount.accountType = "1"
        }
      },
      immediate: true
    },
    accountCode:{
      handler(newVal) {
        if(newVal) {
          if(newVal=="商家账户") {
            this.formAccount.accountCode = this.venderId
            this.formAccount.accountType = "1"
          }else {
            this.formAccount.accountCode = newVal
            this.formAccount.accountType = "2"
          }
        }
      }
    }
  },
  data() {
    return {
      customerPaperwork: {
        shopNameType: 0,
      },
      isKeyActivity: 0,
      placementPosition: [],
      isShowTips: false,
      addArr: [],
      // 1.14迭代 指定入会时间
      // ruleDto:{
      //   plusObject:0, //plus会员
      // },
      formAccount: {
        accountCode: "",
        accountType: ""
      },
      accountCode: "商家账户",
      accountCodeList:[],
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      localStep: this.stepNum,
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
        },
      },
      fileList: [],
      memberLevelPointsDTOList: [
        // {
        //   level:1,
        //   allow:true,
        //   point:10
        // }
      ],
      butActive: 1,
      commodityList: [
        // {
        //   name: "商品类目:",
        //   val: "categoryId",
        //   selectArr: [],
        //   width: 240,
        // },
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      // 表单值
      form: useFormData(this),
      level: [],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        // { value: "非会员", label: 0, point: "", levelName: "非会员" },
        // { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        // { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        // { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        // { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        // { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        quantityTotal: {
          required: true,
          message: "请输入总份数",
          trigger: "blur",
        },
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      quantityBalance: 0,
      quantityBalanceJd: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft:false,
      peopleSelected: [],
    };
  },
  mounted() {
    console.log("this.venderType", this.venderType);
    this.getLevel();
    accountBalance().then((res) => {
      this.quantityBalanceJd = res.data.num;
    });
    if (this.tabActive == 29) {
      this.fileList = [
        {
          url: "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E4%BA%AC%E8%B1%86.png",
          name: "京豆",
        },
      ];
      this.form.logo = "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E4%BA%AC%E8%B1%86.png";
    } else {
      this.fileList = [
        {
          url: "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2E%E5%8D%A1.png",
          name: "E卡",
        },
      ];
      this.form.logo = "https://jdminiapp.yucrm.cn/html/images/conversion/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2E%E5%8D%A1.png";
    }
    this.init();
    if(!this.valueRow){
      this.form.startTime = this.$getDate(30)[0]
      this.form.endTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
  },
  methods: {
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.form.ruleDTO.partner = ["-1"];
      this.form.ruleDTO.firstOpenCardTimeType = 0;
      this.form.ruleDTO.openCardBeforeDay = "";
      this.form.ruleDTO.orderCompleteLimitCount = "";
      this.form.ruleDTO.orderCompleteMaxCount = "";
      this.form.ruleDTO.orderCompleteLimitPayment = "";
      this.form.ruleDTO.orderCompleteMaxPayment = "";
      this.form.ruleDTO.lastOrderCompleteTimeType = 0;
      this.form.ruleDTO.lastOrderCompleteStartDay = "";
      this.form.ruleDTO.lastOrderCompleteEndDay = "";
      this.form.ruleDTO.lastOrderCompleteStartTime = "";
      this.form.ruleDTO.lastOrderCompleteEndTime = "";
      this.form.ruleDTO.plusObject = 0;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList()
        if(res.code==1) {
          let list = res.data
          this.accountCodeList = list.map((item)=>{
            let obj = {}
            obj['accountCode'] = item
            return obj
          })
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          })
        }
      } catch (error) {
        
      }
    },
    upodata(){
      this.$forceUpdate()
    },
     // 更新京豆数
     getAccountBalance(){
      let params = {
        accountCode:this.accountCode,
        accountType:2
      }
      accountBalance(params).then((res) => {
      this.quantityBalanceJd = res.data.num;
    });
    },
    // 回显
    getDetail(){
      inquireActivity(this.valueRow.id).then(res=>{
        let useForm = useFormData(this);
        modifyData(useForm,res.data)
        this.form = useForm
        this.peopleSelected = this.form.ruleDTO.crowdIds ? this.form.ruleDTO.crowdIds.split(',') : [];
        this.form.ruleDTO.activityTargetType = String(this.form.ruleDTO.activityTargetType);
        this.form.ruleDTO.partner = this.form.ruleDTO.allowLevel.split(",");
        this.form.ruleDTO.condFollow = this.form.ruleDTO.condFollow ? true : false;
        this.form.ruleDTO.skuIdList = res.data.ruleDTO.skuIdList
        this.form.activityName = res.data.activityName + (this.activityData.singleCopy?"复制":"");
        // 草稿箱兼容
        this.form.exchangeTimes = this.form.exchangeTimes == -1?null:res.data.exchangeTimes
        this.form.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
        this.form.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
        this.form.quantityTotal = this.form.quantityTotal?this.form.quantityTotal:null
        this.form.startTime = res.data.startTime?res.data.startTime:null;
        this.form.endTime = res.data.endTime?res.data.endTime:null;
        this.isKeyActivity = res.data.isKeyActivity || 0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        this.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : { shopNameType: 0 }
        this.activityTimeChange()
        // 次数
        this.form.frequencyType = res.data.ruleType
        if (this.form.frequencyType == 1) {
          this.form.limitVal = res.data.exchangeDayTimes == -1?"":res.data.exchangeDayTimes
        } else {
          this.form.limitVal = res.data.exchangeTimes == -1?"":res.data.exchangeTimes
        }
        if(this.form.accountType=='1') {
          this.accountCode = "商家账户"
          this.formAccount.accountCode = this.form.accountCode
          this.formAccount.accountType = this.form.accountType
        } else {
          this.accountCode = this.form.accountCode
          this.formAccount.accountCode = this.form.accountCode
          this.formAccount.accountType = this.form.accountType
        }
        // v2.5 复制需求
        if(!this.activityData.singleCopy){
          const checkedLevel = res.data.memberLevelPointsDTOList.filter(item=>item.allow).map(item=>item.level)
          let allLevel = true
          let isAll = true
          this.memberLevelList.forEach(list=>{
            if(!checkedLevel.includes(list.value)){
              allLevel = false
            }
          })
          res.data.memberLevelPointsDTOList.forEach(item=>{
            if(item.allow){
              if(item.point != res.data.memberLevelPointsDTOList[0].point){
                isAll = false
              }
            }
          })
          // 全部会员
          if(allLevel){
            this.memberLe = true
            this.level = this.memberLevelList.map(item=>item.value)
          }else{
            this.memberLe = false
            this.level = checkedLevel
          }
          // 统一设置
          if(isAll){
            this.isLevelSet = false
            this.form.memberLevelPoints = res.data.memberLevelPointsDTOList[0].point
          }else{
            this.isLevelSet = true
            this.memberLevelList.forEach(item=>{
              res.data.memberLevelPointsDTOList.forEach(list=>{
                if(item.value == list.level && list.allow){
                  item.point = list.point
                }
              })
            })
          }
        }
        if(this.activityData.singleCopy){
          //规则
          this.form.ruleDescription = ""
          // 复制移除状态
          delete this.form.status
        }
        // E卡
        if(this.activityData.id == 30){
          this.form.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
          this.form.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
          if(res.data.itemId){
            this.form.assetsId = Number(res.data.itemId)
          }
        }
        this.handleAssidChange()
      })
    },
    init() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "0",
          openMerchant: "",
          openType: 0,
          imageName: "",
          templateUrl: "",
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      if (this.tabActive == 29 || (this.activityData && this.activityData.id == 29)) {
        this.giftList[0].templateUrl = "https://jdminiapp.yucrm.cn/html/images/Preview/jd.png";
        this.giftList[0].imageName = "京豆";
      } else {
        this.giftList[0].templateUrl = "https://jdminiapp.yucrm.cn/html/images/Preview/Ek.png";
        this.giftList[0].imageName = "E卡";
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getCodeIMG() {
      // const data = await prefixurl();
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = `${this.activityData.telCode}/clientPreview?activityType=${this.activityData.id}&venderId=${data.data.venderId}`;
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
      this.$nextTick(() => {
        this.$refs.upload.$children[1].$el.style.display = "none";
      });
    },
    // 套餐内发行总量自动计算
    setQuantityTotal(type) {
      if(type) {
        this.isShowTips = this.form.exchangeSet.some((item)=>item.singleNum>1000)
      }
      this.form.quantityTotal = 0;
      this.form.exchangeSet.forEach((e) => {
        if (e.singleNum && e.total) {
          this.form.quantityTotal += e.singleNum * e.total;
        }
      });
    },
    onShowAddCoupon() {
      if (this.venderType == true) {
        this.selfSupportAddCouponIsShow = true;
      } else {
        this.addCouponIsShow = true;
      }
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = { value: item.customerLevel, label: item.customerLevelName, point: ""};
          return obj
        });
        // 默认全部选中
        this.level = res.data.map(item=>item.customerLevel)
        // 复制、跨店复制、草稿编辑
        if(this.valueRow && this.valueRow.id){
          this.isCopy = this.activityData.singleCopy
          this.getDetail()
        }
      })
    },
    //输入框限制负数
    checkputn0(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
    },
    //输入框限制负数
    checkputn1(e, num = -1) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      if (num != -1 && e.target.value > num) {
        e.target.value = "";
      }
    },
    async handleAssidChange() {
      const { data } = await pointsExchange({ type: 2, itemId: this.form.assetsId });
      this.quantityBalance = data.quantityBalance;
    },
    //返回
    retrunMethod() {
      if(this.isCopy && this.localStep != 0) return this.localStep = 0;
      this.form.activityName = "";
      this.form.logo = "";
      this.form.activityName = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      this.form.startTime = "";
      this.form.endTime = "";
      this.level = [1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      this.form.accountType = "1"
      // this.$emit("returnback");
      if (this.localStep == 0) this.$emit("returnback");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if(!this.form.endTime || !this.form.startTime)return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.form.endTime = null;
        return;
      }
      if (start < nowTime) {
        // this.$message.warning("开始时间不能小于当前时间");
        // this.form.startTime = null;
        // return;
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.form.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }
      this.form.accountType =  this.venderType ? "1" : undefined
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      console.log("------")
      console.log(this.form.startTime,this.form.endTime)
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.form.endTime).getTime() - new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 隐藏添加优惠券组件
    addCouponChange() {
      this.addCouponIsShow = false;
      // console.log(111);
    },
    //取消优惠券
    createActivity() {
      let couponId = this.couponId;
      closeSellerCouponWrite(couponId)
        .then((res) => {
          if (res && res.code == 1) {
            this.butActive = 1;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map(item=>item.value)
      } else {
        this.level = [];
      }
    },

    checkTheChange(val) {
      if (val.length == 5) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    //获取优惠券信息
    addStatus(val) {
      this.butActive = 2;
      this.couponId = Number(val);
      querydetail(this.couponId)
        .then((res) => {
          this.couponTxt = res.data;
          let sum1 = res.data.beginTime.split(" ");
          let sum2 = res.data.endTime.split(" ");
          this.couponTxt.beginTime = sum1[0];
          this.couponTxt.endTime = sum2[0];
          // console.log(res);
        })
        .catch((res) => {});
    },

    //自营店铺获取优惠券信息
    addStatusCoupon(data) {
      console.log("data", data);
      this.butActive = 2;
      this.couponTxt = data;
      let sum1 = data.startTime.split(" ");
      let sum2 = data.endTime.split(" ");
      this.couponTxt.startTime = sum1[0];
      this.couponTxt.endTime = sum2[0];
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getShopList();
      this.getSeller();
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalList = res.data.total;
        // console.log(res, 1111111111);
      });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.commodityList[0].cascaderArr = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择
    chooseShop(val) {
      console.log(val);
      this.form.activityName = val.skuName.substr(0, 15);
      this.form.price = val.jdPrice;
      this.form.wareId = val.categoryId;
      this.form.logo = val.logo;
      this.dialogFormVisible = false;
    },
    searchContent(val) {
      // console.log(val, 2222);
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      // this.formShopList.cascaderArr = val.cascaderArr;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 1024 * 1.5;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 生成规则
    generativerule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";

      let tabName = this.tabActive == 29 ? "京豆" : "E卡";
      //活动名称
      if (this.form.startTime && this.form.endTime) {
        text1 = `活动时间：${this.form.startTime} 至 ${this.form.endTime}`;
      }
      if (this.tabActive == 29) {
        if (this.form.frequencyType == 1) {
          text2 = "兑换次数限制：每人每日可兑换" + this.form.limitVal + "次";
        } else {
          text2 = "兑换次数限制：每人活动期间可兑换" + this.form.limitVal + "次";
        }
      }
      if (this.form.exchangeDayNum || this.form.exchangeNum) {
        text3 = `兑换数量限制：${this.form.exchangeDayNum ? "每人每日可兑换" + this.form.exchangeDayNum + "次" : ""}${
          this.form.exchangeNum ? `${this.form.exchangeDayNum ? "," : ""}每人活动期间可兑换` + this.form.exchangeNum + "次" : ""
        }`;
      } else {
        text3 = `兑换数量限制：不限`;
      }
      this.level.sort();
      if (this.memberLe) {
        text4 = "兑换所需等级：全部会员";
      } else {
        let levelStr = [];
        this.memberLevelList.forEach((item) => {
          if(this.level.includes(item.value)){
            levelStr.push(item.label)
          }
        });
        text4 = "兑换所需等级：" + levelStr.splice(",");
      }
      if (this.isLevelSet) {
        let levelText = [];
        this.level.forEach((item, index) => {
          this.memberLevelList.forEach((it, index) => {
            if (item == it.value) {
              let str = it.label + it.point + "积分=1" + tabName;
              levelText.push(str);
            }
          });
        });
        text5 = "兑换消耗积分:" + levelText.splice(",");
      } else {
        text5 = "兑换消耗积分:" + this.form.memberLevelPoints + "积分=1" + tabName;
      }
      text6 = "奖品数量有限，先到先得，如果积分用于兑换奖品后，不予退回";
      text7 = "实物奖品需商家手动发放，优惠券奖品需手动领取，其它类型奖品会自动发放到你账户，如有疑问请联系在线客服";
      let Arr1 = [text1, text2, text3, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + "。" + "\n";
          newNum = newNum + 1;
        }
      });
      // 1.14迭代 plus会员
      // if(this.ruleDto.plusObject!=0){
      //   newText = newText + newNum + "." + `Plus会员身份：${this.ruleDto.plusObject==1?'Plus会员':'非Plus会员'}` + ";" + "\n";
      // }
      this.form.ruleDescription = newText;
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.setActivity()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.setActivity()
        })
      }
    },
    //创建礼品兑换活动
    async setActivity() {
      let copyForm = JSON.parse(JSON.stringify(this.form));
      if(!this.isDraft){
        //活动创建限制
        if (!this.form.activityName) {
          this.$message.warning("请输入礼品名称");
          return;
        }
        const ruleDTO = this.form.ruleDTO;
        if (ruleDTO.activityTargetType == 3 && !this.peopleSelected.length) {
          this.$message.warning("请选择指定人群");
          return;
        }
        if (ruleDTO.activityTargetType == "2") {
          if (
            ruleDTO.firstOpenCardTimeType == 1 &&
            !ruleDTO.openCardBeforeDay
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.firstOpenCardTimeType == 2 &&
            (!ruleDTO.openCardStartTime || !ruleDTO.openCardEndTime)
          ) {
            this.$message.warning("请完善首次入会时间");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 1 &&
            (!ruleDTO.lastOrderCompleteStartDay &&
              !ruleDTO.lastOrderCompleteEndDay)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
          if (
            ruleDTO.lastOrderCompleteTimeType == 2 &&
            (!ruleDTO.lastOrderCompleteStartTime ||
              !ruleDTO.lastOrderCompleteEndTime)
          ) {
            this.$message.warning("请完善购物条件");
            return;
          }
        }
        if (this.form.ruleDTO.exchangeConditions == 1 && this.tabActive == 30) {
          if(!this.form.ruleDTO.orderEndTime || !this.form.ruleDTO.orderEndTime){
            this.$message.warning("请选择下单时间");
            return;
          };
          if(new Date(this.form.ruleDTO.orderEndTime).getTime() > new Date(this.form.ruleDTO.endTime).getTime()){
            this.$message.warning("下单结束时间不能大于活动结束时间");
            return;
          };
          if(this.form.ruleDTO.filterType != 0 && !this.form.ruleDTO.skuIdList.length){
            this.$message.warning("请选择指定/排除商品");
            return;
          };
          if(!this.form.ruleDTO.orderPaymentLimit){
            this.$message.warning("请输入订单金额限制");
            return;
          }
          if(this.form.ruleDTO.goShopSetting == 1 && !this.form.ruleDTO.goShopAppId){
            this.$message.warning("请输入小程序AppId");
            return;
          }
          if(this.form.ruleDTO.goShopSetting == 2 && !this.form.ruleDTO.goShopUrl){
            this.$message.warning("请输入下单跳转链接");
            return;
          }
        }


        if (!this.form.logo) {
          this.$message.warning("请添加礼品图片");
          return;
        }

        if (!this.form.limitVal && this.tabActive == 29) {
          this.$message.warning("请输入次数限制");
          return;
        }
        if (!this.form.startTime || !this.form.endTime) {
          this.$message.warning("请输入上下架时间");
          return;
        }
        let nowTime = new Date().getTime();
        let start = new Date(this.form.startTime).valueOf();
        let end = new Date(this.form.endTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (end < start) {
          this.$message.warning("结束时间不能小于开始时间");
          return;
        }
        if (this.level.length == 0) {
          this.$message.warning("请输入兑换所需等级");
          return;
        }
        if (!this.form.quantityTotal) {
          this.$message.warning("请输入总份数!");
          return;
        }
        // 兑换所需积分校验
        if(this.isLevelSet){
          let flag = false
          this.memberLevelList.forEach(list=>{
            if(!list.point){
              flag = true
            }
          })
          if(flag)return this.$message.warning("请输入兑换所需积分");
        }else{
          if (!this.form.memberLevelPoints) {
            this.$message.warning("请输入兑换所需积分");
            return;
          }
        }

        if (this.form.quantityTotal * 1 > this.quantityBalance && this.tabActive == 30) return this.$message.warning("发行总量不能大于账户余量");
        if (this.form.quantityTotal * 1 > this.quantityBalanceJd && this.tabActive == 29) return this.$message.warning("发行总量不能大于账户余量");

        if (!this.form.assetsId && this.tabActive == 30) return this.$message.warning("请选择E卡");
        if (!this.form.ruleDescription) {
          this.$message.warning("请输入规则说明");
          return;
        }
        if(this.placementPosition.length==0) {
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      let params = this.venderType ? this.formAccount : {}
      let obj = {
        activityName: this.form.activityName,
        activityType: 29,
        endTime: this.form.endTime,
        exchangeTimes: "",
        logo: this.form.logo,
        memberLevelPointsDTOList: [],
        price: 0,
        quantityTotal: this.form.quantityTotal,
        ruleDescription: this.form.ruleDescription,
        startTime: this.form.startTime,
        ruleType: this.form.frequencyType,
        exchangeType: this.form.exchangeType,
        exchangeDayNum: this.form.exchangeDayNum === "" ? -1 : this.form.exchangeDayNum,
        exchangeNum: this.form.exchangeNum === "" ? -1 : this.form.exchangeNum,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        customerPaperwork: JSON.stringify(this.customerPaperwork),
        ...params
      };
      obj.ruleDTO = this.form.ruleDTO;
      obj.studentSatus = this.form.ruleDTO.studentSatus || "";
      delete obj.ruleDTO.studentSatus;
      obj.ruleDTO.crowdIds = this.peopleSelected.join(",");
      if(obj.ruleDTO.activityTargetType != 2) {
        obj.ruleDTO.allowLevel = "-1";
      } else {
        obj.ruleDTO.allowLevel = obj.ruleDTO.partner.join(",");
      }
      // 处理兑换所需积分
      obj.memberLevelPointsDTOList = this.memberLevelList.map(item=>{
        const checked = this.level.includes(item.value)
        return {
          allow:checked,
          level:item.value,
          levelName:item.label,
          point:checked?this.isLevelSet?item.point:this.form.memberLevelPoints:0
        }
      })

      if (this.form.exchangeType == 1) {
        // 套餐兑换参数转为json
        obj.exchangeSetDTOList = copyForm.exchangeSet;
        let isFlay = false;
        copyForm.exchangeSet.forEach((item) => {
          if (!item.singleNum || !item.total) {
            isFlay = true;
          }
        });
        if (isFlay) return this.$message.warning("请将京豆套餐填写完整");
      }
      if (this.form.frequencyType == 1) {
        obj.exchangeDayTimes = copyForm.limitVal;
      } else {
        obj.exchangeTimes = copyForm.limitVal;
      }

      // if (this.couponTxt.discount != null) {
      //   obj.price = Number(this.couponTxt.discount);
      // } else {
      //   obj.price = this.form.price;
      //   obj.title = this.form.activityName;
      //   obj.wareId = this.form.wareId;
      //   if (this.form.wareId != null) {
      //     obj.giftType = 1;
      //   } else {
      //     obj.giftType = 2;
      //   }
      // }
      obj.activityName = this.form.activityName;
      obj.activityType = this.tabActive;
      // obj.couponId = this.couponId;
      // if (this.form.exchangeTimes != null) {
      //   obj.exchangeTimes = Number(this.form.exchangeTimes);
      // }
      // if (this.form.quantityTotal) {
      //   obj.quantityTotal = Number(this.form.quantityTotal);
      // }

      // obj.safeCoupon = this.couponTxt;
      // obj.takeRule = obj.safeCoupon.limitRule;
      obj.quantityTotal = this.form.quantityTotal?Number(this.form.quantityTotal):null;
      // 草稿箱
      if(this.isDraft){
        obj.status = 5
      }
      // 草稿箱编辑-添加活动id
      if(this.isDraftEdit){
        obj.id = this.valueRow.id
      }
      if(this.isCopy){
        delete obj.id
      }
      let res = {};
      if (this.tabActive == 29) res = await pointsBean(obj);
      if (this.tabActive == 30) {
        let obj1 = {
          logo: obj.logo,
          activityName: obj.activityName,
          ruleDescription: obj.ruleDescription,
          price: this.form.assetsId == 2 ? 1 : this.form.assetsId == 3 ? 5 : this.form.assetsId == 4 ? 20 : this.form.assetsId == 5 ? 50 : 100,
          exchangeTimes: this.form.exchangeNum === "" ? -1 : this.form.exchangeNum,
          quantityTotal: obj.quantityTotal,
          startTime: obj.startTime,
          endTime: obj.endTime,
          memberLevelPoints: obj.memberLevelPoints,
          memberLevelPointsDTOList: obj.memberLevelPointsDTOList,
          exchangeDayTimes: this.form.exchangeDayNum === "" ? -1 : this.form.exchangeDayNum,
          activityType: 30,
          itemId: this.form.assetsId,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        };
        obj1.ruleDTO = this.form.ruleDTO;
        obj1.ruleDTO.crowdIds = this.peopleSelected.join(",");
        if(obj1.ruleDTO.activityTargetType != 2) {
          obj1.ruleDTO.allowLevel = "-1";
        } else {
          obj1.ruleDTO.allowLevel = obj1.ruleDTO.partner.join(",");
        }
        // 草稿箱
        if(this.isDraft){
          obj1.status = 5
        }
        // 草稿箱编辑-添加活动id
        if(this.isDraftEdit){
          obj1.id = this.valueRow.id
        }
        res = await pointsEcard(obj1);
      }
      if (res && res.code == 1) {
        if(this.isDraft){
          this.$emit("returnback",true);
        }else{
          this.memberLevelPointsDTOList = [];
          this.$message.success(res.message);
          // let routeUrl = this.$router.resolve({
          //   path: "/integralCenter/integralMall",
          //   query: { tabAct: 3 },
          // });
          // window.open(routeUrl.href, "_self");
          this.$router.push({
            name: "throw",
            query: {
              id: res.data.id,
              activityType: res.data.activityType,
            },
          });
        }
      } else {
        this.$message.error(res.message);
      }
      // pointsBean(obj).then((res) => {
      //   if (res && res.code == 1) {
      //     this.memberLevelPointsDTOList = [];
      //     this.$message.success(res.message);
      //     let routeUrl = this.$router.resolve({
      //       path: "/integralCenter/integralMall",
      //       query: { tabAct: 3 },
      //     });
      //     window.open(routeUrl.href, "_self");
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // });
    },
    //分页事件
    handleSizeChange(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChange(val) {
      fn;
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>

<style scoped lang="scss">
.level-wrap{
  display: flex;
  /deep/.el-checkbox-group{
    margin-right: 16px;
  }
}
.createPlayStep {
  // height: 100%;
  background: #ffffff;
  padding-bottom: 0;
}

.firststep {
  min-height: 820px;
  box-sizing: border-box;
  padding: 0px 35px 25px;
}
.create_coupons {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // min-height: 880px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 0px 0 0 24px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #fe4d45;
      color: #fe4d45;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 280px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        margin-left: 10px;
        // margin-left: 20px;
        border: 1px solid #fe4d45;
        color: #fe4d45;

        background: rgba(254, 77, 69, 0.1);
        font-size: 13px;
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      color: #fe4d45;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    line-height: 32px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
.pd20 {
  padding: 20px 20px 16px;
}
</style>
